import request from '@/utils/request'

let CoursePeriodApi = {

  /*课时列表*/
  list(data) {
    return request._post('/shop/plus.course_catalog.CoursePeriod/index', data);
},
/*添加课时*/
add(data) {
  return request._post('/shop/plus.course_catalog.CoursePeriod/add', data);
},
/*修改课时*/
edit(data) {
  return request._post('/shop/plus.course_catalog.CoursePeriod/edit', data);
},
/*删除课时*/
del(data) {
  return request._post('/shop/plus.course_catalog.CoursePeriod/del', data);
},
/*课时详情*/
detail(data) {
return request._post('/shop/plus.course_catalog.CoursePeriod/detail', data);
},
}
export default CoursePeriodApi;



// WEBPACK FOOTER //
// ./src/api/course_period.js